import common from '@apps-payroll/locales/en.json';
import leaveSettings from '@apps-payroll/modules/leave-settings/locales/en.json';

const combined = {
  common,
  ...leaveSettings,
};

export default combined;
